import { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import OrganisationBreadCrumb from 'shared/components/bread-crumb/organisation-bread-crumb/organisation-bread-crumb';
import OrganisationTreeNode, { findUpstreamParentBranch } from 'shared/features/organisation/models/organisation-tree-node';
import { useOrganisationUnitTreeContext } from 'shared/features/organisation/providers/organisation-unit-tree-provider';

import { useSendTestEventContextProvider } from '../context/send-test-event-provider';

function SendTestEventOrganisation(): ReactElement {
  const { t } = useTranslation('sendTestEvent');
  const [upstreamParentBranch, setUpstreamParentBranch] = useState<OrganisationTreeNode[]>([]);

  const { organisationUnitTree } = useOrganisationUnitTreeContext();

  const { selectedDevice } = useSendTestEventContextProvider();

  useEffect(() => {
    if (organisationUnitTree && selectedDevice?.organisationUnitId) {
      const upstreamBranch = findUpstreamParentBranch(organisationUnitTree, selectedDevice.organisationUnitId, []);
      setUpstreamParentBranch(upstreamBranch ?? []);
    }
  }, [organisationUnitTree, selectedDevice]);

  return (
    <>
      {selectedDevice?.organisationUnitId ? (
        <OrganisationBreadCrumb rootNodeId={selectedDevice.organisationUnitId} upstreamParentBranch={upstreamParentBranch} />
      ) : (
        <Typography variant="subtitle1">{t('noOrganisationUnitLinkedLabel')}</Typography>
      )}
    </>
  );
}

export default SendTestEventOrganisation;
